import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getAppraisalCategoryList(params) {
  return request({
    url: URL.mdm.basicData.appraisalCategory,
    method: 'get',
    params
  })
}

export function saveAppraisalCategory(data) {
  return request({
    url: URL.mdm.basicData.appraisalCategory,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delAppraisalCategory(data) {
  return request({
    url: URL.mdm.basicData.appraisalCategory,
    method: 'delete',
    data
  })
}
